export default __webpack_public_path__ + "static/media/icon-default-settings.8e8a5c45.svg";